export const featProd = [
  {
    id: 1,
    name: "Gold Chair1",
    descrip: "This is a test description only for dev purposes.",
    price: "$25.49",
    image: require("./asserts/media/scatered-img (1).jpg"),
  },
  {
    id: 2,
    name: "Gold Chair2",
    descrip: "This is a test description only for dev purposes.",
    price: "$26.49",
    image: require("./asserts/media/scatered-img (2).jpg"),
  },
  {
    id: 3,
    name: "Gold Chair3",
    descrip: "This is a test description only for dev purposes.",
    price: "$27.99",
    image: require("./asserts/media/scatered-img (3).jpg"),
  },
  {
    id: 4,
    name: "Gold Chair4",
    descrip: "This is a test description only for dev purposes.",
    price: "$28.99",
    image: require("./asserts/media/scatered-img (4).jpg"),
  },
];

export const topProd = [
  {
    id: 1,
    name: "Gold Chair1",
    descrip: "This is a test description only for dev purposes.",
    price: "$25.49",
    image: require("./asserts/media/scatered-img (1).jpg"),
  },
  {
    id: 2,
    name: "Gold Chair2",
    descrip: "This is a test description only for dev purposes.",
    price: "$26.49",
    image: require("./asserts/media/scatered-img (2).jpg"),
  },
];

export const AllProd = [
  {
    id: 1,
    name: "Gold Chair1",
    category: "furniture",
    numberOfItemsSold: 12,
    createdAt: new Date("1-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 25.49,
    image: require("./asserts/media/scatered-img (1).jpg"),
  },
  {
    id: 2,
    name: "Gold Chair2",
    category: "decor",
    numberOfItemsSold: 10,
    createdAt: new Date("2-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 26.49,
    image: require("./asserts/media/scatered-img (2).jpg"),
  },
  {
    id: 3,
    name: "Gold Chair3",
    category: "wearables",
    numberOfItemsSold: 15,
    createdAt: new Date("3-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 27.99,
    image: require("./asserts/media/scatered-img (3).jpg"),
  },
  {
    id: 4,
    name: "Gold Chair4",
    category: "storage",
    numberOfItemsSold: 5,
    createdAt: new Date("4-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 28.99,
    image: require("./asserts/media/scatered-img (4).jpg"),
  },
  {
    id: 5,
    name: "Gold Chair1",
    category: "furniture",
    numberOfItemsSold: 18,
    createdAt: new Date("5-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 25.49,
    image: require("./asserts/media/scatered-img (1).jpg"),
  },
  {
    id: 6,
    name: "Gold Chair2",
    category: "wearables",
    numberOfItemsSold: 16,
    createdAt: new Date("6-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 26.49,
    image: require("./asserts/media/scatered-img (2).jpg"),
  },
  {
    id: 7,
    name: "Gold Chair3",
    category: "storage",
    numberOfItemsSold: 3,
    createdAt: new Date("7-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 27.99,
    image: require("./asserts/media/scatered-img (3).jpg"),
  },
  {
    id: 8,
    name: "Gold Chair4",
    category: "decor",
    numberOfItemsSold: 21,
    createdAt: new Date("8-2-2022"),
    descrip: "This is a test description only for dev purposes.",
    price: 28.99,
    image: require("./asserts/media/scatered-img (4).jpg"),
  },
];
